import { feathers } from '@/feathers-client';
import { SortOrder } from '@/Core/config/query-mappings';
import ActionFilters from '@/Campaigns/config/action-filters';

export default {
  namespaced: true,

  state: {
    total: null,
    pageSize: 10,
    isLoading: false,
    contactComms: [],
    contactCommsError: null,
  },

  mutations: {
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    setContactComms(state, payload) {
      state.contactComms = payload.items;
      state.total = payload.total;
    },
    setContactCommsError(state, payload) {
      state.contactCommsError = payload;
      state.isLoading = false;
    },
  },

  actions: {
    async findContactCommunications({ commit, rootState }, { contactId, page, sortOrder, filter }) {
      const pageSize = rootState.preferences.contactCommsPageSize;

      const query = {
        is_active: filter.value === ActionFilters.Incomplete.value,
        $skip: pageSize * (page - 1),
        $load: 'send_from_user',
        $limit: pageSize,
      };

      if (sortOrder) {
        query['$sort[send_at]'] = SortOrder[sortOrder];
      }

      let response;
      try {
        commit('setIsLoading', true);
        response = await feathers
          .service(`contacts/${contactId}/campaign-communications`)
          .find({ query });
      } catch (error) {
        commit('setContactCommsError', error.message);
      }
      const { total } = response;
      commit('setContactComms', { items: response.data, total });
      commit('setIsLoading', false);
    },
    async completeContactComm({ commit, dispatch }, { contactId, id, queryParams, filter }) {
      const payload = {
        is_active: filter.value === ActionFilters.Completed.value,
      };

      try {
        commit('setIsLoading', true);
        await feathers.service(`contacts/${contactId}/campaign-communications`).patch(id, payload);

        dispatch('findContactCommunications', queryParams);
      } catch (error) {
        commit('setContactCommsError', error.message);
      }

      commit('setIsLoading', false);
    },
    clearContactCommsError({ commit }) {
      commit('setContactCommsError', null);
    },
  },
};
